
export enum UserClientSettingName {
    Undefined = '', 
    AutoLogoutMinutes = 'AutoLogoutMinutes', 
    RefreshTokenPeriodMinutes = 'RefreshTokenPeriodMinutes'
}


export class UserClientSettingsItem {
    name: UserClientSettingName = UserClientSettingName.Undefined;
    value: string = '';

    constructor(item: UserClientSettingsItem) {
        this.name = item.name;
        this.value = item.value;
    }
}
